import React, { useState, useEffect } from 'react';
import { API_URL } from '../../services/api';
import { Link } from 'react-router-dom';
import {
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Avatar,
  Box,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import PersonIcon from '@mui/icons-material/Person';
import axios from 'axios';

interface DJ {
  id: number;
  name: string;
  photo: string;
  display_order: number;
  active: boolean;
}

const AdminDJs: React.FC = () => {
  const [djs, setDjs] = useState<DJ[]>([]);

  useEffect(() => {
    fetchDJs();
  }, []);

  const fetchDJs = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/djs`);
      setDjs(response.data);
    } catch (error) {
      console.error('Error fetching DJs:', error);
    }
  };

  const handleDelete = async (id: number) => {
    if (window.confirm('¿Estás seguro de eliminar este DJ?')) {
      try {
        const token = localStorage.getItem('token');
        await axios.delete(`${API_URL}/api/djs/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        fetchDJs();
      } catch (error) {
        console.error('Error deleting DJ:', error);
      }
    }
  };

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
        <Typography variant="h4" sx={{ fontWeight: 600 }}>
          Gestión de DJs
        </Typography>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          component={Link}
          to="/admin/djs/new"
        >
          Nuevo DJ
        </Button>
      </Box>

      <TableContainer component={Paper} sx={{ background: 'linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%)' }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Foto</TableCell>
              <TableCell>Nombre</TableCell>
              <TableCell>Orden</TableCell>
              <TableCell>Estado</TableCell>
              <TableCell align="center">Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {djs.map((dj) => (
              <TableRow key={dj.id}>
                <TableCell>
                  {dj.photo ? (
                    <Avatar src={`${API_URL}${dj.photo}`} />
                  ) : (
                    <Avatar>
                      <PersonIcon />
                    </Avatar>
                  )}
                </TableCell>
                <TableCell>{dj.name}</TableCell>
                <TableCell>{dj.display_order}</TableCell>
                <TableCell>{dj.active ? 'Activo' : 'Inactivo'}</TableCell>
                <TableCell align="center">
                  <IconButton
                    size="small"
                    color="primary"
                    component={Link}
                    to={`/admin/djs/edit/${dj.id}`}
                  >
                    <EditIcon />
                  </IconButton>
                  <IconButton
                    size="small"
                    color="error"
                    onClick={() => handleDelete(dj.id)}
                  >
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default AdminDJs;